import script from "./NotifyContainer.vue?vue&type=script&setup=true&lang=js"
export * from "./NotifyContainer.vue?vue&type=script&setup=true&lang=js"

import "./NotifyContainer.vue?vue&type=style&index=0&id=48f03510&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48f03510"]])

export default __exports__